<template>
	<div class="container__radiobuttons">
		<p>{{ label }}</p>
		<div
			v-for="(option, index) in options"
			:key="option.label + index"
			:class="['container__radiobuttons__option', color]"
		>
			<input
				:id="groupName + index"
				type="radio"
				:checked="option.value === value"
				:name="groupName"
				:value="option.value"
				:disabled="disabled"
				@click="changeValue($event)"
			/>
			<label :for="groupName + index">{{ option.label }}</label>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		/**
		 * Nome do grupo de radio button
		 */
		groupName: String,
		/**
		 * label acima dos radio buttons
		 */
		label: String,
		/**
		 * Opções para os radios buttons
		 */
		options: Array,
		/**
		 * Valor que sera feito o bind
		 */
		value: [String, Number, Boolean],
		/**
		 *
		 */
		disabled: { type: Boolean },
		clickListener: Function,
		color: {
			type: String,
			default: 'trv-default',
			validator: (value) => {
				return ['trv-default', 'trv-primary'].indexOf(value) !== -1
			},
		},
	},
	methods: {
		/**
		 * Evento para fazer o bind
		 */
		changeValue(event) {
			const value = event.target.value

			//verifica se valores são booleanos, faz conversão para booleano, evita emitir uma string 'false' ou 'true'
			if (value === 'false' || value === 'true') {
				this.$emit('input', JSON.parse(event.target.value))
			} else {
				this.$emit('input', event.target.value)
			}

			if (this.clickListener) this.clickListener()
		},
	},
}
</script>

<style>
.container__radiobuttons {
	font-size: 0.75rem;
	color: rgb(var(--color-primary));
	user-select: none;
}

.container__radiobuttons > p {
	margin-bottom: 0.1rem;
}

.container__radiobuttons__option {
	display: flex;
	align-items: center;
}

.container__radiobuttons__option > input {
	margin-right: 0.5rem;
	appearance: none;
	height: 15px;
	width: 15px;
	border-radius: 50%;
	position: relative;
	border: 2px solid #a9a9a9;
	outline: none;
}

.container__radiobuttons__option > input::before {
	position: absolute;
	content: '';
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	height: 0;
	width: 0;
	border-radius: 50%;
}

.container__radiobuttons__option.trv-default > input::before {
	background-color: rgb(var(--color-default));
}

.container__radiobuttons__option.trv-primary > input::before {
	background-color: rgb(var(--color-primary));
}

.container__radiobuttons__option > input:checked::before {
	height: 8px;
	width: 8px;
	transition: all 0.2s linear;
}

.container__radiobuttons__option > input:checked + label {
	font-weight: 700;
}
</style>
